import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const TherapeuticPage = lazy(() => import('../pages/services/TherapeuticPage'));
const OrthopedicPage = lazy(() => import('../pages/services/OrthopedicPage'));
const SurgeryPage = lazy(() => import('../pages/services/SurgeryPage'));
const ImplantationPage = lazy(() => import('../pages/services/ImplantationPage'));
const OrthodonticsPage = lazy(() => import('../pages/services/OrthodonticsPage'));
const PreventionPage = lazy(() => import('../pages/services/PreventionPage'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/services/therapeutic',
    element: <TherapeuticPage />
  },
  {
    path: '/services/orthopedic',
    element: <OrthopedicPage />
  },
  {
    path: '/services/surgery',
    element: <SurgeryPage />
  },
  {
    path: '/services/implantation',
    element: <ImplantationPage />
  },
  {
    path: '/services/orthodontics',
    element: <OrthodonticsPage />
  },
  {
    path: '/services/prevention',
    element: <PreventionPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;